import { useGate, useUnit } from 'effector-react'

import { css } from '@portal/styled-system/css'

import { useGoogleOneTap } from '@/features/social-button/google/use-google-one-tap'
import { isPlatformEnabled } from '@/shared/config'
import { useI18n } from '@/shared/lib/i18n'
import { Card } from '@/shared/ui'

import { LoginCardBody } from './card-login'
import { SignupCardBody } from './card-signup'
import * as steps from './steps'

export function HomePageAuthForm() {
    const { i18n } = useI18n()
    useGate(steps.AuthFormGate)

    const step = useUnit(steps.$currentStep)
    const shouldShowOneTap = isPlatformEnabled('gg') && (step === 'login' || step === 'signup_email')

    useGoogleOneTap(shouldShowOneTap)

    return (
        <Card
            styles={css.raw({
                borderRadius: 'medium',
                '@media screen and (min-width: 414px)': {
                    width: '[382px]',
                },
            })}
        >
            <Card.Head
                styles={css.raw({
                    paddingTop: '3',
                    paddingBottom: '2.5',
                    borderTopRadius: 'medium',
                    backgroundColor: step === 'login' ? 'primary' : 'cyan-v2',
                })}
            >
                {step === 'login' ? i18n.PORTAL_LOGIN : i18n.PORTAL_SIGNUP}
            </Card.Head>
            <Card.Body
                styles={css.raw({
                    gap: '2',
                    paddingTop: '3',
                    paddingBottom: '2',
                    paddingX: '[16px]',
                    borderBottomRadius: 'medium',
                    borderColor: step === 'login' ? 'primary' : 'cyan-v2',
                })}
            >
                {step === 'login' ? <LoginCardBody /> : <SignupCardBody />}
            </Card.Body>
        </Card>
    )
}
